export default "__VITE_ASSET__sAPb4wjN__";